import ExtensionIcon from '@material-ui/icons/Extension';
import CrosswordItemsList from './components/CrosswordItemsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.HUNGARY, APP_TYPES.IRELAND],
  allowedRoles: [roles.ADMIN],
  label: 'Crossword Items',
  subMenuName: 'reports',
};

export default {
  list: CrosswordItemsList,
  icon: ExtensionIcon,
  name: 'crosswords/found-items',
  options,
};
